<template>
  <ClientOnly>
    <div
      id="up-navigation-sidebar-container"
      class="w-18 h-screen top-0 left-0 sticky z-10 tracking-normal"
    >
      <UpNavSideBar>
        <template #appLogo>
          <AppLogo />
        </template>
        <template #sidebarOptions>
          <UpNavSidebarOptions
            v-for="option in navSidebarOptions"
            :key="option.name"
            :show-premium-badge="
              Boolean(
                isSidebarOptionPremiumBadgeVisible[option.sidebarOptionName!],
              )
            "
            :display-text="t(option.translationKey ?? '')"
            :icon-name="option.icon ?? ''"
            :is-active="option.name === activeSidebarOption?.sidebarOptionName"
            :is-prefix="Boolean(option.isPrefix)"
            :data-intercom-target="option.dataTarget"
            @click="handleSidebarOptionClick(option)"
          />
        </template>
      </UpNavSideBar>
    </div>
  </ClientOnly>
</template>
<script setup lang="ts">
import { useI18n } from "vue-i18n";
import AppLogo from "~/components/sidebar/AppLogo.vue";
import UpNavSidebarOptions from "~/components/sidebar/UpNavigationSidebar/UpNavSidebarOptions.vue";
import { useUpNavigationStore } from "~/store/upNavigationStore.ts";
import UpNavSideBar from "~/components/sidebar/UpNavigationSidebar/UpNavSideBar.vue";

const { t } = useI18n();
const upNavigationStore = useUpNavigationStore();

const { handleSidebarOptionClick, navSidebarOptions } = upNavigationStore;
const { activeSidebarOption, isSidebarOptionPremiumBadgeVisible } =
  storeToRefs(upNavigationStore);
</script>
